<template>
  <form enctype="multipart/form-data" class="form">
    <div v-if="fileName" class="form__file">
      <icon-base
        icon-name="attachment"
        :label="fileName"
        class="form__file-label"
        @click="$refs.inputFile.click()"
      />
      <icon-base
        icon-name="trash"
        label="Удалить"
        class="form__file-remove"
        @click="onFileRemove"
      />
    </div>
    <div v-else class="form__file">
      <icon-base
        icon-name="upload-file"
        class="form__file-label"
        :label="label"
        @click="$refs.inputFile.click()"
      />
    </div>
    <div class="form__file-hint" v-if="hint">{{ hint }}</div>

    <input
      type="file"
      ref="inputFile"
      class="form__input"
      @change="onFileChange"
    />
  </form>
</template>

<script>
import IconBase from '../Icons/IconBase.vue'

export default {
  name: 'File',
  components: { IconBase },
  props: {
    modelValue: {
      type: File,
      default: null,
    },
    label: {
      type: String,
      default: 'Загрузить файл',
    },
    hint: {
      type: String,
      default: '',
    },
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0]
      file && this.$emit('update:modelValue', file)
    },
    onFileRemove() {
      this.$emit('update:modelValue', null)
    },
  },
  computed: {
    fileName() {
      return this.modelValue?.name || false
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  $root: &;

  display: inline-block;

  &__file {
    display: flex;
    align-items: center;
    gap: $space-lg;

    &-label {
      display: flex;
      align-items: center;
      gap: $space-xxxxs;
      cursor: pointer;
    }

    &-remove {
      display: none;
      cursor: pointer;
      color: $color-red;
    }

    &:hover {
      #{$root}__file-remove {
        display: flex;
      }
    }
  }

  &__file-hint {
    font-size: $font-size-xs;
    color: $form-list-label-color;
    margin: 0;
    font-style: italic;
    margin-top: 8px;
  }

  &__input {
    visibility: hidden;
    opacity: 0;
    height: 0;
    width: 0;
  }
}
</style>
